/**
 * Safely parses a fetch Response as JSON.
 * Returns null for the data if the response body is not valid JSON.
 */
export async function safeJsonParse<T = any>(
  response: Response
): Promise<{ response: Response; data: T }> {
  try {
    const data: T = await response.json();
    return { response, data };
  } catch {
    return { response, data: null as unknown as T };
  }
}

/**
 * Builds a URL with properly encoded query parameters.
 * Usage: buildUrl(`${getBasePath()}/endpoint`, { id: myId, name: myName })
 */
export function buildUrl(
  base: string,
  params: Record<string, string | number | boolean | undefined | null>
): string {
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  }
  const qs = searchParams.toString();
  return qs ? `${base}?${qs}` : base;
}
